import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于国产自拍视频精选合集的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/70 transition-colors"
                onClick={() => toggleFAQ(idx)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.question}</h3>
                <span
                  className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    openIndex === idx ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}